<script>
export default {
  beforeMount: function () {
    var moduleName = this.$options.name

    if (this.$route.query.clean) {
      this.filters = {}
      this.page = 1

      if (this.$store.state[moduleName]) {
        this.$store.commit(moduleName + '/SET_LIST_QUERY', { page: 1, filters: {} })
      }

      let query = Object.assign({}, this.$route.query)
      delete query.clean
      this.$router.replace({ query }).catch(() => {})

      return
    }

    var savedQuery = this.$store.state[moduleName] ? this.$store.state[moduleName].listQuery : null

    if (savedQuery && savedQuery.filters && Object.keys(savedQuery.filters).length > 0) {
      this.page = savedQuery.page || 1
      Object.keys(savedQuery.filters).forEach(key => {
        this.$set(this.filters, key, savedQuery.filters[key])
      })
    } else {
      Object.keys(this.$route.query).forEach(key => {
        if (key === 'page') {
          this.page = parseInt(this.$route.query.page)
        } else {
          let val = this.$route.query[key]
          this.$set(this.filters, key, Array.isArray(val) && typeof val === 'string' ? [val] : val)
        }
      })
    }
  },
  methods: {
    setURLQueryParams (config) {
      Object.keys(config).forEach(key => { if (!config[key]) { delete config[key] } })
      try {
        this.$router.replace({ name: this.$route.name, query: config }).catch(() => {
        })
      } catch (err) {
        if (err.name !== 'NavigationDuplicated') {
          console.log(err)
        }
      }
    },
    resetFilters () {
      this.loadingList = true
      var datePickerFields = []
      Object.keys(this.filters).forEach(key => {
        if (Array.isArray(this.filters[key])) {
          this.filters[key] = []
        } else if (this.isDatePickerField(key) &&
        !(this.getDatePickerFieldName(key) in datePickerFields)) {
          datePickerFields.push(this.getDatePickerFieldName(key))
        } else {
          this.filters[key] = null
        }
      })
      datePickerFields.forEach(key => {
        this.$refs[key].clear()
      })
      this.loadingList = false
    },
    applyFilters () {
      this.getPage(1)
    },
    isDatePickerField (filterKey) {
      return !isNaN(filterKey.slice(-1))
    },
    getDatePickerFieldName (filterKey) {
      return filterKey.slice(0, filterKey.length - 2)
    },
    getPage (page) {
      if (this.loadingList) { return }
      this.loadingList = true
      this.page = page
      var filters = {}
      Object.keys(this.filters).forEach((key) => {
        filters[key] = this.filters[key] && this.filters[key].id ? this.filters[key].id : this.filters[key]
      })
      var moduleName = this.$options.name
      if (this.$store.commit && moduleName) {
        try {
          this.$store.commit(moduleName + '/SET_LIST_QUERY', {
            page: this.page,
            filters: JSON.parse(JSON.stringify(this.filters))
          })
        } catch (e) {
          console.error('[Mixin] Error saving in Vuex:', e)
        }
      }

      var config = Object.assign(filters, {page: this.page})
      this.setURLQueryParams(config)

      return this.getObjects(config).then(
        response => {
          this.objects = response
          this.loadingList = false
        }
      )
    }
  },
  data () {
    return {
      page: 1,
      filters: {},
      loadingList: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/mixins/PaginatedFilteredListMixin.vue